// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DetailOutlinedSvg from "@fishx/icons-svg/es/asn/DetailOutlined";
import FishxIcon from '../components/FishxIcon';

var DetailOutlined = function DetailOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DetailOutlinedSvg
  }));
};

DetailOutlined.displayName = 'DetailOutlined';
export default React.forwardRef(DetailOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DetailOutlined.js
// module id = 2403
// module chunks = 0